<script>
import TicketDetail from './TicketDetail.vue';

// The ticket's details beside the list, so the list, its filters and its page
// stay where they are. "Open full page" goes to the ticket's own page.
export default {
  name: 'CoLivingTicketSidePanel',
  components: { TicketDetail },
  props: {
    ticketId: { type: String, required: true },
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    onKeydown(event) {
      if (event.code !== 'Escape') return;
      // A dialog opened from the panel (reason, assign, booking) closes first.
      if (document.querySelector('.modal-mask, [data-base-modal]')) return;
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div
    class="fixed inset-0 z-40 flex justify-end"
    data-testid="co-living-ticket-panel"
  >
    <div
      class="absolute inset-0 bg-slate-900/40"
      data-testid="co-living-panel-backdrop"
      @click="$emit('close')"
    />
    <aside
      class="relative flex flex-col w-full max-w-xl h-full bg-slate-50 dark:bg-slate-900 shadow-xl"
      role="dialog"
      aria-modal="true"
      :aria-label="ticketId"
    >
      <header
        class="flex items-center justify-between gap-2 px-4 py-3 bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700"
      >
        <h2
          class="m-0 text-lg font-medium text-slate-900 dark:text-slate-100"
          data-testid="co-living-panel-title"
        >
          {{ ticketId }}
        </h2>
        <div class="flex items-center gap-1">
          <woot-button
            variant="clear"
            size="small"
            icon="open"
            data-testid="co-living-panel-open-full"
            @click="$emit('expand')"
          >
            {{ $t('CO_LIVING.TICKETS.PANEL.OPEN_FULL_PAGE') }}
          </woot-button>
          <woot-button
            v-tooltip.left="$t('CO_LIVING.TICKETS.PANEL.CLOSE')"
            variant="clear"
            size="small"
            color-scheme="secondary"
            icon="dismiss"
            :aria-label="$t('CO_LIVING.TICKETS.PANEL.CLOSE')"
            data-testid="co-living-panel-close"
            @click="$emit('close')"
          />
        </div>
      </header>
      <div class="flex-1 p-4 overflow-auto">
        <TicketDetail
          :ticket-id="ticketId"
          compact
          @changed="$emit('changed')"
        />
      </div>
    </aside>
  </div>
</template>
